import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import classnames from 'classnames';
import React, { ChangeEvent, FocusEvent, FormEvent } from 'react';
import { Flex, FormInput, Label } from '@grubhubprod/gh-cookbook-react';
import { IDatePickerInputComponentProps } from 'src/components/DatePickerInput/DatePickerInput';
import { FormInputContentWrapper } from 'src/components/common/FormInputContentWrapper/FormInputContentWrapper';

export interface IFormInputProps {
  label?: string | JSX.Element;
  ariaLabel?: string;
  id: string;
  error?: {
    message?: string;
    [key: string]: unknown;
  };
  subDescription?: string;
}

export interface IInputProps extends IFormInputProps {
  type?: 'text' | 'tel' | 'email';
  placeholder?: string;
  name: string;
  value?: string;
  maxLength?: number;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onInput?: (event: FormEvent<HTMLInputElement>) => void;
  prefixIcon?: JSX.Element;
  disabled?: boolean;
  datePickerInputComponentProps?: IDatePickerInputComponentProps;
  inputStyle?: React.CSSProperties;
  isSmall?: boolean;
  blockWidth?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, IInputProps>(
  function inputElement(
    {
      label,
      ariaLabel,
      id,
      name,
      error,
      type = 'text',
      placeholder = '',
      value,
      subDescription,
      prefixIcon,
      datePickerInputComponentProps,
      disabled,
      maxLength,
      onFocus,
      onBlur,
      onChange,
      onInput,
      inputStyle,
      isSmall,
      blockWidth,
    },
    ref
  ) {
    const errorMessage = get(error, 'message');
    const hasError = !!errorMessage;
    const hasPrefix = !!prefixIcon;

    return (
      <FormInput
        inputSize="medium"
        error={error}
        helperText={subDescription}
        blockWidth={blockWidth}
      >
        {label && <Label htmlFor={id}>{label}</Label>}
        <FormInputContentWrapper>
          <div className="inputContainer">
            <input
              style={inputStyle}
              aria-label={ariaLabel}
              className={classnames('input', {
                hasError,
                hasPrefix,
                disabled,
                small: isSmall,
              })}
              id={id}
              name={name}
              type={type}
              ref={ref}
              disabled={disabled}
              placeholder={placeholder}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onChange}
              onInput={onInput}
              autoComplete="off"
              data-testid={`${name}-input`}
              readOnly={!!datePickerInputComponentProps}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(value !== undefined && { value })}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(maxLength !== undefined && { maxLength })}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(datePickerInputComponentProps !== undefined &&
                datePickerInputComponentProps)}
            />
            {prefixIcon && (
              <Flex height="100%" alignItems="center" className="prefixIcon">
                {prefixIcon}
              </Flex>
            )}
          </div>
        </FormInputContentWrapper>
      </FormInput>
    );
  }
);
